import { Component } from '@theme/component';
import { fetchConfig } from '@theme/utilities';
import { CartAddEvent } from '@theme/events';

/**
 * Mini-cart upsell : ajoute un produit fixe puis laisse le thème
 * re-render les sections panier via le morphing natif.
 */
class CartUpsellComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this.#onClick);
  }

  /** @param {MouseEvent} event */
  #onClick = (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-upsell-add]');
    if (!(button instanceof HTMLButtonElement)) return;
    event.preventDefault();
    this.#addToCart(button);
  };

  /** @param {HTMLButtonElement} button */
  async #addToCart(button) {
    const variantId = button.dataset.upsellAdd;
    if (!variantId || button.getAttribute('aria-disabled') === 'true') return;

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('cart-upsell__button--loading');

    // On collecte les sections de TOUS les paniers présents (drawer + page),
    // exactement comme le fait component-cart-items.js.
    const sectionIds = new Set();
    for (const el of document.querySelectorAll('cart-items-component')) {
      if (el instanceof HTMLElement && el.dataset.sectionId) sectionIds.add(el.dataset.sectionId);
    }

    const body = JSON.stringify({
      items: [{ id: Number(variantId), quantity: 1 }],
      sections: Array.from(sectionIds).join(','),
      sections_url: window.location.pathname,
    });

    try {
      const response = await fetch(Theme.routes.cart_add_url, fetchConfig('json', { body }));
      const data = await response.json();

      if (data.status) {
        console.error('[cart-upsell]', data.description || data.message);
        return;
      }

      // CartAddEvent.eventName === 'cart:update' → capté par cart-items-component,
      // qui morphe la/les section(s) à partir de data.sections.
      this.dispatchEvent(
        new CartAddEvent(data, this.id || 'cart-upsell-component', {
          source: 'cart-upsell-component',
          variantId,
          sections: data.sections,
        })
      );
    } catch (error) {
      console.error('[cart-upsell]', error);
    } finally {
      button.removeAttribute('aria-disabled');
      button.classList.remove('cart-upsell__button--loading');
    }
  }
}

if (!customElements.get('cart-upsell-component')) {
  customElements.define('cart-upsell-component', CartUpsellComponent);
}